// Esporta un array di stringhe per le liste nelle card
export const listItems1 = ["Test Fisico dal vivo GRATUITO",
                           "1 Lezione Iniziale Inclusa",
                           "Programma Di Allenamento",
                           "Check Progressioni",
                           "30 € per ogni lezione aggiuntiva",
                            "",
                            "",
                            
                            ];

export const listItems2 = ["Test Fisico dal vivo GRATUITO",
                            "1 Lezione Iniziale Inclusa",
                            "Programma Di Allenamento",
                            "Check Progressioni",
                            "3 Lezioni ( 1 a Settimana )",
                            "25 € per ogni lezione aggiuntiva"];

export const listItems3 = ["Test Fisico dal vivo GRATUITO",
                           "1 Lezione Iniziale Inclusa",
                           "Programma Di Allenamento",
                           "Check Progressioni",
                           "6 Lezioni ( 1 a Settimana )",
                           "22 € per ogni lezione aggiuntiva"];